import { readStoredLocale } from './locale-storage';
import { AppLocale, normalizeLocale, SOURCE_LOCALE } from './locales';

/**
 * Параметр адреса с языком: `?lang=en`. Его добавляют ссылки устройства (оверлей и пульт),
 * потому что встроенный браузер OBS отдаёт `navigator.languages` по языку интерфейса самого
 * OBS (`[язык OBS, 'en-US', 'en']`), а не по выбору организатора.
 */
export const LOCALE_QUERY_PARAM = 'lang';

function browserLanguages(): readonly string[] {
  const { languages, language } = window.navigator;
  return languages && languages.length > 0 ? languages : [language];
}

/**
 * Язык интерфейса при старте: `?lang=` в адресе → сохранённый выбор → первое поддерживаемое из
 * **всех** предпочтений браузера → исходный русский (полное покрытие и основная аудитория).
 *
 * Язык из адреса не сохраняется: он принадлежит ссылке, а не браузеру, и не должен перебивать
 * выбор человека на других страницах.
 *
 * `@lingui/detect-locale` не подходит: его `fromNavigator` смотрит только на
 * `navigator.language`, и при `['de-DE', 'en-US']` интерфейс остался бы русским.
 */
export function detectLocale(search: string = window.location.search): AppLocale {
  const fromQuery = normalizeLocale(new URLSearchParams(search).get(LOCALE_QUERY_PARAM));
  if (fromQuery) {
    return fromQuery;
  }

  const stored = readStoredLocale();
  if (stored) {
    return stored;
  }

  for (const tag of browserLanguages()) {
    const locale = normalizeLocale(tag);
    if (locale) {
      return locale;
    }
  }

  return SOURCE_LOCALE;
}
